<!--
  agent-checkout.vue
  
  2025-06-04: Created agent checkout component with agent ID field and date display
  2024-03-21: Added query param support for agent_id
-->
<template>
  <v-dialog
    :value="show"
    @input="$emit('update:show', $event)"
    max-width="500px"
    persistent
  >
    <v-card class="agent-checkout rounded-xl">
      <v-card-title class="d-flex align-center justify-space-between">
        <span class="text-h6 font-weight-semibold">{{
          $t("agent_reserve")
        }}</span>
        <v-btn icon @click="$emit('update:show', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <!-- Check-in/Check-out dates display -->
        <v-card
          v-if="dateRange && dateRange.startDate && dateRange.endDate"
          outlined
          class="mb-4"
        >
          <v-card-text class="py-2">
            <div class="d-flex justify-space-around align-center">
              <div class="text-center">
                <div class="text-caption grey--text">{{ $t("check_in") }}</div>
                <div class="font-weight-medium">
                  {{ parseDate(dateRange.startDate, "MMM DD, YYYY") }}
                </div>
              </div>
              <v-divider vertical />
              <div class="text-center">
                <div class="text-caption grey--text">{{ $t("check_out") }}</div>
                <div class="font-weight-medium">
                  {{ parseDate(dateRange.endDate, "MMM DD, YYYY") }}
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-form ref="agentForm" lazy-validation @submit.prevent="save">
          <v-row>
            <v-col cols="12" class="" v-if="!queryAgentId">
              <v-text-field
                v-model="agentReservation.agent_id"
                name="agent_id"
                :label="$t('agent_id')"
                type="text"
                outlined
                dense
                :rules="[required]"
                required
                hint="Enter your agent identification number"
                persistent-hint
              />
            </v-col>
            <!-- <v-col cols="12" class="">
              <v-textarea
                v-model="agentReservation.note"
                outlined
                :placeholder="$t('comments')"
                :label="$t('additional_notes')"
                style="min-height: 100px"
                rows="4"
              />
            </v-col> -->
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="px-6 pb-4">
        <v-btn text @click="$emit('update:show', false)">
          {{ $t("cancel") }}
        </v-btn>
        <v-spacer />
        <v-btn
          :color="actionsColor"
          class="white--text"
          elevation="0"
          :loading="isLoading"
          @click="save"
        >
          {{ $t("submit_reservation") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FormRules from "@/mixins/form-rules-mixin";
import StylesMixin from "@/mixins/styles-mixin";
import FormattersMixin from "@/mixins/formatters-mixin";

export default {
  name: "AgentCheckout",
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    listing: {
      type: Object,
      required: true,
    },
    currentPricing: {
      type: Object,
      default: null,
    },
    dateRange: {
      type: Object,
      default: null,
    },
  },
  mixins: [FormRules, StylesMixin, FormattersMixin],
  data() {
    return {
      isLoading: false,
      queryAgentId: this.$route.query.agent_id || null,
      agentReservation: {
        agent_id: this.$route.query.agent_id || "",
        full_name: "",
        email: "",
        phone: "",
        note: "",
      },
    };
  },
  methods: {
    async save() {
      if (!this.$refs.agentForm.validate()) return;

      this.isLoading = true;

      const reservationData = {
        ...this.agentReservation,
        listing_id: this.listing.id,
        check_in: this.dateRange?.startDate,
        check_out: this.dateRange?.endDate,
        reservation_type: "agent",
      };

      this.$emit("save", reservationData);
      this.isLoading = false;
    },
    resetForm() {
      this.agentReservation = {
        agent_id: this.queryAgentId || "",
        full_name: "",
        email: "",
        phone: "",
        note: "",
      };
      if (this.$refs.agentForm) {
        this.$refs.agentForm.resetValidation();
      }
    },
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.agent-checkout {
  .v-card__title {
    border-bottom: 1px solid #e0e0e0;
  }
}
</style>
